/* ==========================================================================
   B&B – Scroll reveal (bb-reveal.js)
   Content in the B&B homepage sections fades and rises into place as it
   scrolls into view, with a small stagger between items in the same row.
   - Nothing is hidden unless this script runs (no-JS visitors see everything).
   - Off for visitors who have reduced motion turned on.
   - Anything already on screen at load appears immediately, without animating.
   To animate something new, add its selector to TARGETS below.
   ========================================================================== */

(() => {
  if (window.bbRevealLoaded) return;
  window.bbRevealLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) return;

  const TARGETS = [
    /* Quick shop */      '.bb-qs__intro', '.bb-qs__tile',
    /* Essence */         '.bb-es__story', '.bb-es__point',
    /* The edit */        '.bb-ed__head', '.bb-ed__tile',
    /* Shop by style */   '.bb-sbs__head', '.bb-sbs__item', '.bb-sbs__footer',
    /* Product grid */    '.bb-pg__head', '.bb-pg__item',
    /* Featured product */'.bb-fp__media', '.bb-fp__content',
    /* Story */           '.bb-st__content', '.bb-st__main', '.bb-st__secondary',
    /* Journal */         '.bb-jr__head', '.bb-jr__card',
    /* World */           '.bb-wd__head', '.bb-wd__tile',
    /* Testimonials */    '.bb-ts__head', '.bb-ts__item',
    /* Newsletter */      '.bb-nl__box', '.bb-nl__signup'
  ].join(',');

  const STAGGER_MS = 90;
  const MAX_STEPS = 5;

  document.documentElement.classList.add('bb-reveal-ready');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  const scan = (root) => {
    root.querySelectorAll(TARGETS).forEach((el) => {
      if (el.classList.contains('bb-reveal')) return;

      // Stagger items that sit side by side in the same parent
      const siblings = Array.from(el.parentElement.children).filter((child) => child.matches(TARGETS));
      const step = Math.min(siblings.indexOf(el), MAX_STEPS);
      el.style.setProperty('--bb-reveal-delay', `${step * STAGGER_MS}ms`);

      const rect = el.getBoundingClientRect();
      const onScreen = rect.top < window.innerHeight && rect.bottom > 0;

      el.classList.add('bb-reveal');
      if (onScreen) {
        el.classList.add('is-revealed'); // already visible: no animation
      } else {
        observer.observe(el);
      }
    });
  };

  const start = () => scan(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme editor: re-scan a section when it's changed in Customize
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();